import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Breadcrumb from './Breadcrumb';
import SkGeciciTaslakHeaderMenu from './SkGeciciTaslakHeaderMenu';

const isTechServicePanelRole = (rol) => {
  const r = (rol && String(rol).toLowerCase()) || '';
  return (
    r === 'tech-service' ||
    r === 'teknikservis' ||
    r === 'techservice' ||
    r === 'teknik-servis'
  );
};

const TopHeader = ({
  desktopSidebarCollapsed,
  onToggleDesktopSidebar,
  showSantralToggle,
  santralOpen,
  onToggleSantral,
  santralHasIncoming,
}) => {
  const location = useLocation();
  const { user } = useAuth();
  const [serviceName, setServiceName] = useState(null);

  const panelTechServiceTitle = useMemo(() => {
    if (!user || !isTechServicePanelRole(user.rol)) return null;
    const ad = user.techServiceAd;
    return ad && String(ad).trim() ? String(ad).trim() : null;
  }, [user]);

  useEffect(() => {
    const isEditPage = location.pathname.includes('/tech-services/') && location.pathname.includes('/edit');
    const isServiceRecordCreatePage = location.pathname.includes('/service-records/create');

    if (isEditPage) {
      const name = window.currentTechServiceName || null;
      setServiceName(name);

      const interval = setInterval(() => {
        const currentName = window.currentTechServiceName || null;
        setServiceName((prevName) => (currentName !== prevName ? currentName : prevName));
      }, 500);

      return () => clearInterval(interval);
    }

    if (isServiceRecordCreatePage) {
      const interval = setInterval(() => {}, 100);
      return () => clearInterval(interval);
    }

    setServiceName(null);
    return undefined;
  }, [location.pathname]);

  return (
    <div className="top-header">
      <div className="top-header-content">
        {typeof onToggleDesktopSidebar === 'function' ? (
          <button
            type="button"
            className="top-header-sidebar-toggle"
            onClick={onToggleDesktopSidebar}
            aria-label={desktopSidebarCollapsed ? 'Kenar çubuğunu aç' : 'Kenar çubuğunu gizle'}
            title={desktopSidebarCollapsed ? 'Menüyü aç' : 'Menüyü gizle'}
          >
            <i className={`fas fa-angle-double-${desktopSidebarCollapsed ? 'right' : 'left'}`} aria-hidden />
          </button>
        ) : null}
        <div className="top-header-breadcrumb-slot">
          <Breadcrumb serviceName={serviceName} />
        </div>
        {panelTechServiceTitle ? (
          <div className="top-header-service-title" title={panelTechServiceTitle}>
            <i className="fas fa-tools" aria-hidden />
            <span className="top-header-service-title__text">{panelTechServiceTitle}</span>
          </div>
        ) : null}

        {showSantralToggle ? (
          <>
            <SkGeciciTaslakHeaderMenu />
            <button
            type="button"
            className={`top-header-santral-btn${santralOpen ? ' top-header-santral-btn--active' : ''}${santralHasIncoming ? ' top-header-santral-btn--ringing' : ''}`}
            onClick={onToggleSantral}
            aria-label={santralOpen ? 'Santral panelini kapat' : 'Santral panelini aç'}
            title={santralOpen ? 'Santralı kapat' : 'Santral'}
          >
            <i className={`fas fa-${santralOpen ? 'chevron-right' : 'phone-volume'}`} aria-hidden />
            {santralHasIncoming && !santralOpen ? (
              <span className="top-header-santral-badge" aria-hidden />
            ) : null}
          </button>
          </>
        ) : (
          <SkGeciciTaslakHeaderMenu />
        )}
      </div>
    </div>
  );
};

export default TopHeader;
